import { Injectable, NgZone } from '@angular/core';
import {
  MatLegacySnackBar as MatSnackBar,
  MatLegacySnackBarRef as MatSnackBarRef,
  LegacyTextOnlySnackBar as TextOnlySnackBar,
  MatLegacySnackBarConfig as MatSnackBarConfig,
} from '@angular/material/legacy-snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  _duration = 5000;

  constructor(
    public snackBar: MatSnackBar,
    private ngZone: NgZone,
  ) {}

  /**
   * Ouvre toujours la snackbar dans la zone Angular. Certaines erreurs HTTP sont résolues
   * hors zone (ex. la chaîne de promesses MSAL lors d'un acquireTokenSilent asynchrone) :
   * un `snackBar.open` exécuté hors zone crée bien l'overlay mais la détection de changement
   * ne tourne pas, et la snackbar n'est jamais rendue. `ngZone.run` garantit l'affichage.
   */
  private open(
    message: string,
    action: string,
    config: MatSnackBarConfig,
  ): MatSnackBarRef<TextOnlySnackBar> {
    // `ngZone.run` garantit l'ouverture dans la zone Angular. Certaines erreurs HTTP sont
    // résolues hors zone (chaîne de promesses MSAL lors d'un acquireTokenSilent asynchrone) ;
    // un `snackBar.open` hors zone crée l'overlay mais la détection de changement ne tourne pas.
    return this.ngZone.run(() => this.snackBar.open(message, action, config));
  }

  success(message: string) {
    this.open(message, '', {
      duration: 10000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-success'],
    });
  }

  warning(message: string, duration: number = 5000) {
    this.open(message, '', {
      duration: duration,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-warning'],
    });
  }

  danger(message: string) {
    this.open(message, '', {
      duration: 5000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-danger'],
    });
  }

  info(message: string, actionLabel: string = ''): MatSnackBarRef<TextOnlySnackBar> {
    return this.open(message, actionLabel, {
      duration: actionLabel ? 0 : this._duration,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-warning'],
    });
  }

  copyToClipboard(message: string) {
    this.open(message + ' copié !', '', {
      duration: 500,
      horizontalPosition: 'center',
      panelClass: ['snackbar-white'],
    });
  }

  successList(identifiers: string[]) {
    const msg = `Précommandes créées :\n${identifiers.join('\n')}`;
    this.open(msg, '', {
      duration: this._duration * 2,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-success', 'snackbar-multiline'],
    });
  }

  dismissAll() {
    this.snackBar.dismiss();
  }
}
